<template>
  <b-overlay
    :show="loader"
    opacity="0.50"
    rounded="sm"
  >
    Periodos:
    <v-select
      v-model="objperiodo"
      :options="periodos"
      :reduce="period => period"
      label="clave"
      value="periodo"
      filterable
      placeholder="Selecciona"
      :clearable="false"
      @input="(val) => $emit('selectedperiodo', val)"
    >
      <template #no-options>
        Selecciona primero el plan de estudios
      </template>
    </v-select>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { periodsFromPlan } from '@/views/public/oferta-academica/useDetalleOferta'
import {
  ref, watch, onMounted,
} from '@vue/composition-api'

export default {
  components: {
    vSelect,
    BOverlay,
  },
  props: {
    idplan: {
      type: [Number],
      default: 1,
    },
    hide: {
      type: Number,
      default: null,
    },
    reinsc: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const periodos = ref([])
    const objperiodo = ref(null)
    const loader = ref(false)
    const loadPeriodos = () => {
      loader.value = true
      periodsFromPlan(props.idplan).then(response => {
        let datos = response
        if (props.hide !== null) {
          if (props.hide > 0) datos = response.filter(item => item.periodo !== props.hide)
        }
        // eslint-disable-next-line prefer-destructuring, no-nested-ternary
        objperiodo.value = (props.reinsc && datos[1]) ? datos[1] : (datos[0]) ? datos[0] : null
        emit('selectedperiodo', objperiodo.value)
        periodos.value = datos
        loader.value = false
      }, error => {
        if (error) loader.value = false
      })
    }
    watch(() => props.idplan, value => {
      if (value != null) {
        periodos.value = []
        loadPeriodos()
      }
    })
    onMounted(() => { loadPeriodos() })
    return {
      periodos,
      loader,
      objperiodo,
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
